/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { responsiveThreshold } from '../constants';

import { Section } from './Section.styled';

/**
 * Same as Section but stacks its contained columns vertically when resized below
 * a threshold width.
 */
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResponsiveSection = styled(Section)`
	@media (max-width: ${responsiveThreshold}px) {
		flex-direction: column;
		justify-content: flex-start;
	}
`;
